import React from 'react';
// Mock data for L&T IT Helpdesk

const USERS = [
  { id: "alex",   name: "Alex Mullin",       email: "alexmullin@leeandthompson.com",   color: "#5B6CFF", initials: "AM" },
  { id: "fiona",  name: "Fiona Norman",      email: "fionanorman@leeandthompson.com",  color: "#E0719A", initials: "FN" },
  { id: "rob",    name: "Rob Hilton",        email: "robhilton@leeandthompson.com",    color: "#3FA76A", initials: "RH" },
  { id: "ed",     name: "Ed Osagie",         email: "edosagie@leeandthompson.com",     color: "#E08A2E", initials: "EO" },
  { id: "james",  name: "James Clydesdale",  email: "jamesclydesdale@leeandthompson.com", color: "#7B5DC9", initials: "JC" },
];

let ME_ID = "james"; // overwritten at runtime once SSO resolves the logged-in user
// Imports are immutable bindings - mutate via this setter. Importers reading
// ME_ID still see the updated value (ES module live bindings).
const setMeId = (id) => { ME_ID = id; window.ME_ID = id; };

// Realistic L&T staff requesters (mock M365 user link)
const REQUESTERS = [
  { id: "swhitfield", name: "Sarah Whitfield", email: "sarahwhitfield@leeandthompson.com", dept: "Corporate", color: "#C46B5C" },
  { id: "tbailey",    name: "Tom Bailey",       email: "tombailey@leeandthompson.com",       dept: "Litigation", color: "#6A8EAE" },
  { id: "rmccann",    name: "Rebecca McCann",   email: "rebeccamccann@leeandthompson.com",   dept: "Real Estate", color: "#8E6AAA" },
  { id: "dpatel",     name: "Deepa Patel",      email: "deepapatel@leeandthompson.com",      dept: "Finance", color: "#3F8E8A" },
  { id: "jharper",    name: "Jonathan Harper",  email: "jharper@leeandthompson.com",         dept: "Partners", color: "#A06B3F" },
  { id: "lokafor",    name: "Lola Okafor",      email: "lolaokafor@leeandthompson.com",      dept: "HR", color: "#C9577E" },
  { id: "msong",      name: "Michael Song",     email: "michaelsong@leeandthompson.com",     dept: "Trainee", color: "#5C7AC4" },
  { id: "ehernandez", name: "Eva Hernandez",    email: "evahernandez@leeandthompson.com",    dept: "Tax", color: "#8AAE6A" },
  { id: "nfaroukh",   name: "Nadia Faroukh",    email: "nfaroukh@leeandthompson.com",        dept: "Compliance", color: "#B07A2E" },
  { id: "rgreene",    name: "Richard Greene",   email: "rgreene@leeandthompson.com",         dept: "Banking", color: "#5C8C9B" },
  { id: "ablack",     name: "Anna Black",       email: "annablack@leeandthompson.com",       dept: "Knowledge", color: "#A03F6E" },
  { id: "phughes",    name: "Paul Hughes",      email: "paulhughes@leeandthompson.com",      dept: "Corporate", color: "#3F8E5C" },
];

// Top-level categories from the export
const CATEGORIES = [
  { id: "GENERAL",     label: "General" },
  { id: "COMPLIANCE",  label: "Compliance" },
  { id: "HARDWARE",    label: "Hardware" },
  { id: "REQUESTS",    label: "Requests" },
  { id: "SERVERS",     label: "Servers / IT Systems" },
  { id: "SOFTWARE",    label: "Software" },
  { id: "TELECOMS",    label: "Telecoms" },
];

// Curated subcategory list (lifted directly from the user's CSV)
const SUBCATS = {
  COMPLIANCE: ["Active Directory","Archive Request","Client File Sharing","Data Access Requests","Data Breach","File Access","Information Barrier","M365 Azure","O365 Exchange","Software licencing","Unblock Country","User Account Creation","User Account Deletion"],
  HARDWARE:   ["Boardroom 1 (Teams)","Boardroom 2 (Zoom)","Green Room (Teams)","Teams Room 1","Teams Room 2","Townhall","Desks","Desktop PCs","Docks","Headphones","Laptop","Mobile Phones","Office Monitors (BenQ)","Printer"],
  REQUESTS:   ["Equipment","General","Training"],
  SERVERS:    ["General"],
  SOFTWARE:   ["1Password","Adobe","Adobe Reader","AI","Big Hand","BundleDocs","CleanDocs / Recipient Check","CodeTwo","compareDocs","DISCO","DocuSign","Dragon Dictation","Dropbox","Duo","E-Days","Elite 3E","Evolution","Firmex","FortiClient","Internet","iOS","Kofax","Litera Compare","Mimecast","MS Excel","MS OneNote","MS Outlook","MS PowerPoint","MS Teams","MS Word","NetDocuments","O365","OneDrive","pdfDocs","Riliance","SAGE","Secure Data Management","SentinelOne","SharePoint","SysAid","VinciWorks LMS","Windows","Wordpress","Zoom"],
};

const PRIORITIES = [
  { id: "urgent", label: "Urgent" },
  { id: "high",   label: "High" },
  { id: "medium", label: "Medium" },
  { id: "low",    label: "Low" },
];

const STATUSES = [
  { id: "new",      label: "New",         tone: "new" },
  { id: "progress", label: "In Progress", tone: "prog" },
  { id: "waiting",  label: "Waiting for response", tone: "prog" },
  { id: "resolved", label: "Closed",      tone: "closed" },
];

// Submission channel. Was previously 33 entries with each IT person × each
// channel (Alex (Email), James (Teams), etc.) - but "who took it" is already
// captured by the Assignee field, so the per-person variants were duplicate
// data and made the dropdown too tall to open downward.
//
// Helpdesk (...) = the shared triage@ mailbox / shared phone / shared Teams.
// Email / In Person / IM/Mobile (without prefix) = direct to an individual
// IT staff member.
//
// Existing tickets in the DB keep their original "Alex (Email)" style strings
// - nothing migrates. Over time the list naturally cleans itself.
const LOCATIONS = [
  "User Submission",
  "Power Automate",
  "Helpdesk (Telephone)",
  "Helpdesk (Email)",
  "Helpdesk (Teams)",
  "Email",
  "In Person",
  "IM/Mobile",
  "Other",
];

// Tickets now live in SQL - empty placeholder kept for the legacy export.
// The _DEMO_* arrays that used to live here (sample tickets, mailbox,
// KB articles) were deleted 2026-07-22: they were dead code, and worse,
// they shipped real IT security procedures (Duo bypass process, 1Password
// recovery, leaver offboarding) + staff names in the PUBLIC js bundle -
// the SWA serves static assets unauthenticated. Do not re-add demo
// content containing real procedures or real names.
const TICKETS = [];

// Knowledge base
// Articles now live in SQL via /api/kb. This empty array is kept as a
// placeholder so legacy references (e.g. tickets.jsx suggestedKB) don't crash.
// The real KB list is loaded into state.kbArticles by app.jsx on mount.
const KB_ARTICLES = [];

const KB_TAGS = ["new-starter","outlook","netdocs","vpn","duo","1password","printers","docusign","teams","bighand","compliance","iphone"];

// Table columns + saved views
const ALL_COLUMNS = [
  { id: "id",          label: "ID",            width: 78 },
  { id: "status",      label: "Status",        width: 168 },
  { id: "priority",    label: "Priority",      width: 92 },
  { id: "subject",     label: "Subject",       width: 320, flex: true, required: true },
  { id: "description", label: "Description",   width: 280, flex: true },
  { id: "category",    label: "Category",      width: 140 },
  { id: "subcat",      label: "Sub-Category",  width: 160 },
  { id: "location",    label: "Location",      width: 150 },
  { id: "requester",   label: "Requester",     width: 180 },
  { id: "assignee",    label: "Assignee",      width: 150 },
  { id: "requestTime", label: "Request time",  width: 132 },
  { id: "closeTime",   label: "Close time",    width: 132 },
  { id: "solution",    label: "Solution",      width: 260, flex: true },
];

const BUILTIN_VIEWS = [
  { id: "default",  name: "Default",       columns: ["id","status","priority","subject","category","subcat","location","requester","assignee","requestTime"] },
  { id: "compact",  name: "Compact",       columns: ["id","status","subject","subcat","requester","assignee","requestTime"] },
  { id: "triage",   name: "Triage queue",  columns: ["id","status","priority","subject","subcat","requester","requestTime"] },
  { id: "byperson", name: "By person",     columns: ["id","status","priority","subject","requester","assignee","requestTime"] },
  { id: "resolved", name: "Resolved",      columns: ["id","status","subject","requester","assignee","requestTime","closeTime","solution"] },
];

const MAILBOX = [];

// Expose to all babel scripts
export {
  USERS, REQUESTERS, ME_ID,
  CATEGORIES, SUBCATS, PRIORITIES, STATUSES, LOCATIONS,
  TICKETS, KB_ARTICLES, KB_TAGS,
  ALL_COLUMNS, BUILTIN_VIEWS, MAILBOX, setMeId,
};
